import React from 'react'
import ResponsiveStyles from '../components/ResponsiveStyles'
import Header from '../components/Header'
import HeroSection from '../components/HeroSection'
import HowItWorksSection from '../components/HowItWorksSection'
import FeaturesSection from '../components/FeaturesSection'
import EcosystemSection from '../components/EcosystemSection'
import AudienceSection from '../components/AudienceSection'
import RoadmapSection from '../components/RoadmapSection'
import PricingSection from '../components/PricingSection'
import FAQSection from '../components/FAQSection'
import CTASection from '../components/CTASection'
import Footer from '../components/Footer'

// Section order is an argument: what it is and how big (hero + figures) →
// how it works → what you can do → what it is beneath → who relies on it →
// where it is going → what it costs → the questions left → the ask.
const HomePage = ({ membershipPath = '/membership', signInPath = '/sign-in', signUpPath = '/sign-up', currentUser }) => {
  return (
    <div>
      <ResponsiveStyles />
      <Header signInPath={signInPath} signUpPath={signUpPath} currentUser={currentUser} />
      <main>
        <HeroSection signUpPath={signUpPath} />
        <HowItWorksSection />
        <FeaturesSection />
        <EcosystemSection />
        <AudienceSection />
        <RoadmapSection />
        <PricingSection variant="home" membershipPath={membershipPath} signUpPath={signUpPath} currentUser={currentUser} />
        <FAQSection />
        <CTASection signUpPath={signUpPath} signInPath={signInPath} />
      </main>
      <Footer />
    </div>
  )
}

export default HomePage
